module.exports = __webpack_public_path__ + "img/offer_list_icon.78b95b27.svg";